module.exports = __webpack_public_path__ + "static/media/challenge_icon_dark.08fae115.svg";